// called in both the classic and block editor

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import {SENTRY_DSN, KEEN_PROJECT_ID, KEEN_KEY} from './utility';
import KeenTracking from 'keen-tracking';
import './global.css';
// global object
// Lets wait for the window to load properly & then check if the window.AP object exists
window.addEventListener("load", (event) => {
	if(window && typeof window.AP != 'object'){
		window.AP = {};
	}
	if(window && typeof window.AP.tanalytics != 'object'){
		window.AP.tanalytics = {
			track: (eventName, meta) => {
			},
			identify: (userMetadata) => {
			}
		}
	}
});

export default function initializeTracking(){
	try{
		// Sentry Integration: 
		Sentry.init({
		  dsn: SENTRY_DSN,
		  integrations: [new Integrations.BrowserTracing()],
		  tracesSampleRate: 1.0,
		  attachStacktrace: true
		});

		// Analytics tracking
		const keenClient = new KeenTracking({
		  projectId: KEEN_PROJECT_ID,
		  writeKey: KEEN_KEY
		});
		window.AP.tanalytics = {
		  track: (eventName, meta) => {
		    if(AP.currentUser && AP.currentUser.email){
		      meta = Object.assign({}, meta, AP.currentUser);
		    }
		    keenClient.recordEvent(eventName, meta);
		  },
		  identify: (userMetadata) => {
		    AP.currentUser = userMetadata;
		  }
		}
	}catch(e){
		console.log('error in global initialization')
	}
}